import Game from "../../../../src/Game";
import BaseSimpleButton from "../../../../src/entities/UI/BaseButton";
import { EnumEventBus, EventBus } from "../managers/EventBus";
import { RootEventBus,EnumRootEventBus } from "../../../../src/managers/RootEventBus";
import { BaseSButtonStyle } from "../../../../src/types/Interface";
import { RANDOM_BUTTON_COORD } from "../types/Config";


const ButtonStyle: BaseSButtonStyle = {
  width: 280,
  height: 120,
  wordWrapWidth: 160,
  defaultColor: 0xCECECE,
  hoverColor: 0xDEDEDE,
  pressedColor: 0xC5C5C5,
  borderColor: 0x111111,
  titleColor: 0x111111,
  titleFontSize: 28,
  borderRadius: 22
}


export default class GenRanQuadriButton extends BaseSimpleButton {
  private Game = Game.getInstance();
  private RootEventBus = RootEventBus;
  private EventBus = EventBus;
  constructor() {
    super("Generate Random Quadrilateral", ButtonStyle, () => this.createRandomQuadri())
    this.addCoord();
    this.setVisible(false);
    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => this.setVisible(true));
  }
  createRandomQuadri = () => this.EventBus.emit(EnumEventBus.generateRandomQuadri);
  setVisible = (v: boolean) => this.visible = v;
  addCoord() {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      this.x = RANDOM_BUTTON_COORD.x;
      this.y = RANDOM_BUTTON_COORD.y;
      return
    }
    this.x = dim.WIDTH / 2 - 200;
    this.y = dim.HEIGHT / 2 + 400;
  }
}